// extracted by mini-css-extract-plugin
export default {"info":"style_info__4nFR1","image":"style_image__aJB4Z","content":"style_content__JE1mg","item":"style_item__3KitZ"};